document.addEventListener("DOMContentLoaded", () => {
  const groups = document.querySelectorAll(".ncv-facet--flavour-type");

  groups.forEach((group) => {
    const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
    const allLink = group.querySelector("[data-ncv-flavour-all]");

    const getSelectedValue = () => {
      const checked = radios.find((r) => r.checked);
      return checked ? checked.value : "";
    };

    const syncSelectedStyles = () => {
      radios.forEach((radio) => {
        const label = radio.closest("label");
        if (!label) return;
        label.classList.toggle("is-selected", radio.checked);
      });

      if (allLink) {
        const anyChecked = radios.some((r) => r.checked);
        allLink.classList.toggle("is-selected", !anyChecked);
      }

      group.dataset.ncvSelected = getSelectedValue();
    };

    // initial state
    syncSelectedStyles();

    // ✅ Clicking the already-selected pill should clear back to All
    group.addEventListener("click", (e) => {
      const label = e.target.closest("[data-ncv-flavour-pill]");
      if (!label) return;

      const radio = label.querySelector('input[type="radio"]');
      if (!radio) return;

      const current = group.dataset.ncvSelected || "";
      const clicked = radio.value;

      // If they clicked the one that's already selected, clear filters
      if (current && current === clicked) {
        e.preventDefault();
        e.stopPropagation();
        if (allLink && allLink.href) window.location.href = allLink.href;
      }
      // Otherwise: do nothing, let the radio change normally (Dawn will submit)
    });

    // ✅ When selection changes, Dawn will do its thing. We only update styles.
    group.addEventListener("change", (e) => {
      const input = e.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (input.type !== "radio") return;

      syncSelectedStyles();
    });
  });
});
